import Sidebar from './Sidebar/Sidebar'

import './page-frame.scss'
import { useCreatePaymentMutation, useSessionQuery } from '../../api/api'
import LoadingBlocker from '../LoadingSpinner/LoadingBlocker'
import useIsSubscribed from '../../utils/hooks/useIsSubscribed'
import SubscriptionModal from '../Subscription/SubscriptionModal'
import { useState } from 'react'

const PageFrame = ({ route, children, showBanner }) => {
  const { data: user } = useSessionQuery()
  const [subscriptionModalIsOpen, setSubscriptionModalIsOpen] = useState(false)
  const isSubscribed = user?.isSubscribed
  const hasSubscribed = user?.hasSubscribed

  return (
    <div className="page-frame">
      <Sidebar route={route} />
      <div className="content">
        {!isSubscribed && !hasSubscribed && showBanner ? (
          <>
            <div className="pl-7 pr-4 bg-purple flex items-center h-[50px] text-white">
              <h5 className="">Free Mode:</h5>
              <div className="flex-fill flex items-center text-sm ml-2 mt-1 ">
                Full access to all features. Limited amounts of tracks,
                playlists and portfolios available.
              </div>
              <div>
                <button
                  className="button bg-purple-light hover:bg-purple-light-med relative"
                  onClick={() => setSubscriptionModalIsOpen(true)}
                >
                  Upgrade Now
                </button>
              </div>
            </div>
            <div className="h-[calc(100%-50px)]">{children}</div>
          </>
        ) : (
          <>{children}</>
        )}
      </div>
      {subscriptionModalIsOpen ? (
        <SubscriptionModal
          isOpen={subscriptionModalIsOpen}
          onRequestClose={() => setSubscriptionModalIsOpen(false)}
        />
      ) : null}
    </div>
  )
}

export default PageFrame
